import { BaseEntity } from "yt-ng-framework";

export class RadnoMesto extends BaseEntity{
    constructor(){
        super()
    }


    Naziv: string=null;
    Sifra: string=null;
    MinSpremaID: number=null;
    TataID: number=null;
    Items: RadnoMesto[]=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Sifra = input.Sifra;
        this.MinSpremaID = input.MinSpremaID;
        this.TataID = input.TataID;        
        if (input.Items!=null){
            this.Items=[];
            input.Items.forEach(Item => {
                return this.Items.push(new RadnoMesto().Deserialize(Item))
            });
        }

        return this;
    }

    Serialize(input:RadnoMesto){
        input.Items = null;
        return input;
    }
}